import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import st from './MultiSelectWithCheckBox.module.scss'
import Checkbox from 'components/ContentBox/Global/Checkbox/Checkbox'
import cn from 'classnames'
import { ReactComponent as ArrowDown } from 'components/UI/icons/arrow-down-s-line.svg'

function MultiSelectWithCheckBox({
  options,
  onChange,
  currentCard,
  translation,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)

  // Закрытие при клике вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleCheckboxChange = (value) => {
    onChange(value)
  }

  const isEmployeeChecked = (optionValue) => {
    if (!currentCard?.employees) return false

    const numericOptionId = Number(optionValue)

    return currentCard.employees.some((emp) => {
      if (emp && typeof emp === 'object' && 'id' in emp) {
        return emp.id === numericOptionId
      }
      return Number(emp) === numericOptionId
    })
  }

  const getEmployeeName = (employeeId) => {
    const employee = options.find((opt) => opt.value === employeeId.toString())
    return employee?.label || ''
  }

  const getDisplayName = (employee) => {
    if (employee && typeof employee === 'object' && 'full_name' in employee) {
      return employee.full_name
    }
    if (employee && typeof employee === 'object' && 'name' in employee) {
      return employee.name
    }
    if (employee && typeof employee === 'object' && 'id' in employee) {
      return getEmployeeName(employee.id)
    }
    return getEmployeeName(employee)
  }

  const getEmployeeId = (employee) => {
    if (employee && typeof employee === 'object' && 'id' in employee) {
      return employee.id
    }
    return employee
  }

  const handleHeaderClick = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionClick = (optionValue) => {
    handleCheckboxChange(optionValue)
  }

  const handleRemoveClick = (employeeId, e) => {
    e?.stopPropagation?.() // Безопасный вызов stopPropagation
    handleCheckboxChange(employeeId)
  }

  return (
    <div className={st.multiSelect} ref={containerRef}>
      <div className={st.multiSelectHeader} onClick={handleHeaderClick}>
        {translation?.select_options || 'Выбрать ответственного:'}
        <ArrowDown className={cn(st.arrowIcon, { [st.rotated]: isOpen })} />
      </div>

      {isOpen && (
        <div className={st.multiSelectOptions}>
          {options.map((option) => {
            const isChecked = isEmployeeChecked(option.value)

            return (
              <div
                key={option.value}
                className={cn(st.multiSelectOption, {
                  [st.highlighted]: isChecked,
                })}
                onClick={(e) => e.stopPropagation()} // Предотвращаем закрытие при клике на опцию
              >
                <Checkbox
                  onChange={() => handleOptionClick(option.value)}
                  checked={isChecked}
                  name={option.value}
                  label={option.label}
                />
                {isChecked && <span className={st.verticalLine}></span>}
              </div>
            )
          })}
        </div>
      )}

      <div className={st.multiSelectSelected}>
        {currentCard?.employees?.map((employee, index) => {
          const employeeId = getEmployeeId(employee)
          const displayName = getDisplayName(employee)

          if (!displayName) return null

          return (
            <div key={`${employeeId}${index}`} className={st.selectedOption}>
              <div className={st.fullName}>{displayName}</div>
              <span
                className={st.removeOption}
                onClick={(e) => handleRemoveClick(employeeId, e)}
              >
                x
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

MultiSelectWithCheckBox.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  currentCard: PropTypes.shape({
    employees: PropTypes.array,
  }),
  translation: PropTypes.object,
}

export default MultiSelectWithCheckBox
